module.exports = __webpack_public_path__ + "img/enging_room_pic07.6c0ac237.png";